<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :addButtonIcon="addButtonIcon"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :useModelInsteadOfButton="useModelInsteadOfButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
        :isLoss="isLoss"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue"; 
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    isLoss: {
      type: Boolean,
      default: false,
    },
    cropLotId: {
      type: String,
      default: null,
    },
    modelNameSingular: String,
    addButtonIcon:{
      type: String,
      default: "mdi-seed-off-outline",
    }
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      if(this.cropLotId){
        this.$apollo
          .query({
            query: LOAD_NEW_EXIT_STORAGE_ADJUSTMENT_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              cropLotId: this.cropLotId,
            }
          })
          .then(response => {
            this.entry = response.data.accountContext.exitStorageAdjustment;
            // console.log("entry lot", this.entry);
            this.entry.isLoss = this.isLoss;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }else{
        this.$apollo
          .query({
            query: LOAD_NEW_EXIT_STORAGE_ADJUSTMENT_QUERY,
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.entry = response.data.accountContext.exitStorageAdjustment;     
            // console.log("entry aqui", this.entry);     
            this.entry.isLoss = this.isLoss;          
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }
    },
    createServerEntry: function(field) {
      // console.log("STOCK_ADJUSTMENT", field, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(field, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_EXIT_STORAGE_ADJUSTMENT,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(field, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createExitStorageAdjustment.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createExitStorageAdjustment.exitStorageAdjustment);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_EXIT_STORAGE_ADJUSTMENT_QUERY = gql `
  query($cropLotId: ID){
    accountContext{
      exitStorageAdjustment(cropLotId: $cropLotId) {
        id
        code
        date
        description
        removeFromStorage
        isStockEntryType
        storageId
        exitMovementItemsAttributes {
          id
          quantity
          packagingId
          packaging{
            id
            name
          }
          itemId
          item{
            id
            name
          }
          exitMovementItemLotsAttributes{
            manufacturingLotId
            name
            quantity
          }
        }
        dummyExitMovementItemsAttributes {
          id
        }
        stockAdjustmentReasonId
        validations
      }
      allStorages {
        id
        name
        location
      }
      allGreenhouses{
        id
        name
        location
      }
      allStockAdjustmentReasons {
        id
        name
      }
    }
  }
`;

const CREATE_EXIT_STORAGE_ADJUSTMENT = gql `
  mutation($input: ExitStorageAdjustmentCreateInputObject!) {
    createExitStorageAdjustment(input: $input) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
